import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import About from '../components/About';
import Education from '../components/Education';
import Projects from '../components/Projects';
import WebDeveloperShowcase from '../components/WebDeveloperShowcase';
import Contact from '../components/Contact';
import Navbar from '../components/Navbar';
import ScrollToTop from '../components/ScrollToTop';
import SeoHead from '../components/SeoHead';
import ActivityMap from '../components/ActivityMap';
import { pathToSectionId } from '../routes';

const HomePage: React.FC = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const sectionId = pathToSectionId(pathname);
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname]);

  return (
    <div>
      <SeoHead />
      <Navbar />
      <Hero />
      <About />
      <Education />
      <Projects />
      <WebDeveloperShowcase />
      <ActivityMap />
      <Contact />
      <footer className="border-t border-slate-800 bg-slate-950 py-6 text-center text-sm text-slate-300">
        © 2026 Michal Chamrád. All rights reserved.
      </footer>
      <ScrollToTop />
    </div>
  );
};

export default HomePage;
